module.exports = {"id":"dp3_2l1q1","text":"Integrating and re-elaborating digital content","instructions":"Why is acknowledging reused digital content considered important?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l1q1-a1","text":"It supports ethical and transparent reuse practices","score":1.8},{"id":"dp3_2l1q1-a2","text":"It improves file compatibility between systems","score":0},{"id":"dp3_2l1q1-a3","text":"It automatically grants reuse permission","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l1q1.json
// module id = 1130
// module chunks = 41